import React, { FC } from "react";
import { useUser } from "src/hooks/useUser";
import { isUser } from "src/lib/globalTypes";
import { Org, User } from "src/lib/graphql/types";
import { TabOption } from "./ProfileData";

type NoProfileProjectsProps = {
  entity:
    | Pick<User, "fullName" | "shortname">
    | Pick<Org, "name" | "shortname">;
  type: TabOption;
};

const NoProfileProjects: FC<NoProfileProjectsProps> = ({
  entity,
  type,
}) => {
  const [user] = useUser();

  const me = isUser(entity) && entity.shortname === user?.shortname;
  const hasAccess =
    me ||
    user?.memberOf?.find((info) => info.org?.shortname === entity.shortname);
  const name = isUser(entity) ? entity.fullName : (entity as Org).name;

  const typeString = type.value === "All" ? "" : type.value.toLowerCase();

  return (
    <div className="no-profile-results normal-text">
      <h3 className="no-profile-results-header">
        {hasAccess
          ? `No ${typeString} projects`
          : `No public ${typeString} projects`}
      </h3>
      <div className="no-profile-results-message">
        {
          `${name} hasn't yet made any of their ${typeString} projects public.`
        }
      </div>
    </div>
  );
};

export default NoProfileProjects;
